import gsap from "gsap";


const TextMedia = (() => {

    const SELECTOR_MODULE = '.module-container__text-media';


    const initialize = () => {

        const modules = document.querySelectorAll(SELECTOR_MODULE);

        if (!modules?.length) return;

        modules.forEach((m => {

            // only when data-animate set
            if (m.dataset.animate) {

                initAnimations(m);
            }

        }));

    };

    const initAnimations = (module) => {

        const contentTextWrapperElements = module.querySelectorAll('.content__text__wrapper > *');
        const imageElement = module.querySelectorAll('.content__media img');


        const tl = gsap.timeline({
             scrollTrigger: {
                    trigger: contentTextWrapperElements,
                    start: "top bottom",
                    end: "top center",
                    scrub: true,
                }
        }).from(contentTextWrapperElements,
            { autoAlpha: 0, y: 50, ease: "none", duration: 1, stagger: 0.3 },

        ).from(imageElement, {
            duration: 1,
            filter: "blur(4px)"
        }, "<");

    };


    return {
        initialize
    }

})();


export default TextMedia;
